import React, { useCallback, useEffect, useMemo, useState } from "react";

import PageHeader from "components/UniversalComponents/PageHeader";
import { MainBody, Ptag } from "components/core";
import { ClaimsMisHeader, SearchBarWrapper } from "../../Claims/styles";
import { debounce } from "lodash";
import http from "services/httpService";
import FilterBar from "pages/Claims/Mis/FilterBar";
import ClaimsTable from "pages/Claims/components/ClaimsTable";
import SearchBar from "pages/Claims/Mis/SearchBar";
import BaseBreadcrumbs from "components/core/BaseBreadcrumbs";
import ClaimMisDownload from "./ClaimMisDownload";
import { ClaimSearchFilterWrapper } from "./styles";

function ClaimsEmployeeMis() {
  const [loading, setLoading] = useState(true);
  const [searchStr, setSearchStr] = useState("");
  const [headers, setHeaders] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [filterValue, setFilterValue] = useState([]);
  const [filterArray, setFilterArray] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async (value) => {
    try {
      let payload = {};
      if (value) {
        payload.filter_query_string = value;
      }

      if (searchStr) {
        payload.search_query_string = searchStr;
      }
      const { data } = await http.get("business/get_mis_claims/", {
        params: payload,
      });
      setHeaders(data.headers);
      setTableData(data.claim_mis);
      !value && statusArray(data.claim_mis);
      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  const statusArray = (value) => {
    const statusReducer = (acc, val) => {
      if (!acc.includes(val.claim_status)) {
        acc.push(val.claim_status);
      }
      return acc;
    };

    const accurateValue = value.reduce(statusReducer, []).sort();
    setFilterValue(accurateValue);
    return accurateValue;
  };

  const debouncedSearchHandler = useCallback(
    debounce(async (value) => {
      let payload = {};
      console.log({ value });
      if (value) {
        payload.search_query_string = value;
      }

      if (searchStr) {
        payload.filter_query_string = filterArray;
      }
      try {
        const { data } = await http.get("business/get_mis_claims/", {
          params: payload,
        });
        setTableData(data.claim_mis);
        console.log(data);
      } catch {}
    }, 500),
    []
  );

  const searchHandler = (e) => {
    const value = e.target.value;
    setSearchStr(value);
    debouncedSearchHandler(value);
  };

  const filterHandler = useMemo(() => {
    const new_array = Array.from(filterArray);
    console.log(new_array, new_array.length);
    if (!new_array.length) {
      fetchData();
      return;
    }
    const search_string = JSON.stringify(Array.from(filterArray));
    fetchData(search_string);
  }, [filterArray]);

  const crumbs = useMemo(() => {
    return [
      {
        name: "Claims",
        path: "/v1/claims",
      },
      { name: "Detailed Summary", active: true },
    ];
  }, []);

  return (
    <>
      <BaseBreadcrumbs breadcrumbs={crumbs} />
      <SearchBarWrapper>
        <ClaimSearchFilterWrapper>
          <SearchBar value={searchStr} onChange={searchHandler} />
          <FilterBar filters={filterValue} onChange={setFilterArray} />
        </ClaimSearchFilterWrapper>
        <ClaimMisDownload />
      </SearchBarWrapper>
      <ClaimsTable headers={headers} rows={tableData} />
    </>
  );
}

export default ClaimsEmployeeMis;
